import React from 'react';
import clsx from 'clsx';
import Title from './Title';
import Close from './Close';
import styles from './Header.css';

interface Props {
    dataTestId: string;
    children: React.ReactNode;
    contentCls?: string;
}

const Header = ({ dataTestId, children, contentCls }: Props) => {
    return (
        <div data-testid={dataTestId} className={clsx(styles.contentContainer, contentCls)}>
            {children}
        </div>
    );
};

Header.Title = Title;
Header.Close = Close;

export default Header;
